/**
 * Size guide dialog — opens the native <dialog> rendered by snippets/size-guide.liquid.
 *
 * showModal() is the whole reason this file exists: it gives the focus trap, Esc to close, the
 * implicit aria-modal and focus returned to the trigger, all from the platform. The only thing
 * left to write is "open it", "close it", and a backdrop click.
 *
 * 🔑 DELEGATED FROM `document`, and it caches no element references. The trigger and the dialog
 * both live inside <variant-picker>, which Horizon re-renders and MORPHS on every variant change —
 * anything bound directly to those nodes would be silently dropped the first time a shopper
 * changed colour. A script re-inserted by morph does not execute either, so re-binding would never
 * happen. Delegation sidesteps both. Same reasoning as snippets/enquire-to-order.liquid.
 *
 * Loaded as a module, so this body runs exactly once per page however many times the snippet
 * emits the <script> tag.
 */

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('[data-fd-size-guide]');
  if (trigger instanceof HTMLElement) {
    const dialog = document.getElementById(trigger.dataset.fdSizeGuide ?? '');
    if (dialog instanceof HTMLDialogElement) {
      event.preventDefault();
      dialog.showModal();
    }
    return;
  }

  if (target.closest('[data-fd-size-guide-close]')) {
    target.closest('dialog')?.close();
    return;
  }

  // Backdrop: a click landing on the <dialog> itself is outside the inner panel, because the panel
  // covers the whole dialog box. Guarded on our own class so no other dialog is affected.
  if (target instanceof HTMLDialogElement && target.classList.contains('fd-size-guide')) {
    target.close();
  }
});